<template>
    <v-card>
        <v-card-title>
            用户管理
            <v-spacer></v-spacer>
            <router-link style="" to="/">
                <v-img src="../assets/newclose.png"></v-img>
            </router-link>
        </v-card-title>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="margin-right: 20px ; margin-top: 20px" color="#7FACD6" @click="add">
                新建
            </v-btn>
            <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="搜索"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-actions>
        <v-data-table
                :headers="headers"
                :items="applications"
                :search="search"
                :loading="loading"
                loading-text="正在查询"
                no-data-text="无"
        >
            <template v-slot:item.option="{ item }">
                <v-icon @click="edit(item)" class="mr-2">mdi-pencil</v-icon>
                <v-icon @click="[dialog = true,deleteTmp = item]">mdi-delete</v-icon>
            </template>
        </v-data-table>
        <v-card-actions>
            <v-spacer></v-spacer>
        </v-card-actions>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="500">
                <v-card>
                    <v-card-title class="headline">提示</v-card-title>
                    <v-card-text>
                        确认删除吗？
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#368FC8" @click="dialog = false">取消</v-btn>
                        <v-btn color="#368FC8" @click="deleteUser(deleteTmp)">确认</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-overlay :value="overlay">
            <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
            ></v-progress-circular>
        </v-overlay>

        <v-row justify="center">
            <v-dialog v-model="card" persistent max-width="500">
                <v-card>
                    <v-card-title class="headline">{{title}}
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form">
                            <v-text-field
                                    label="用户名"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="user.username"
                            ></v-text-field>

                            <v-text-field
                                    v-if="action === 'add'"
                                    label="密码"
                                    type="password"
                                    :rules="[rules.required]"
                                    v-model="user.password"
                            ></v-text-field>

                            <v-text-field
                                    v-if="action === 'add'"
                                    label="确认密码"
                                    type="password"
                                    :rules="[rules.confirmPassword]"
                                    v-model="confirmPassword"
                            ></v-text-field>
                            <v-text-field
                                    v-if="action === 'edit'"
                                    label="密码"
                                    type="password"
                                    v-model="user.password"
                            ></v-text-field>

                            <v-text-field
                                    v-if="action === 'edit'"
                                    label="确认密码"
                                    type="password"
                                    :rules="[rules.confirmPassword]"
                                    v-model="confirmPassword"
                            ></v-text-field>

                            <v-text-field
                                    label="姓名"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="user.name"
                            ></v-text-field>
                            <v-text-field v-if="$store.state.webUser.hospital"
                                          label="电话号码"
                                          type="text"
                                          :rules="[rules.required]"
                                          v-model="user.phoneNumber"
                            ></v-text-field>
                            <v-text-field
                                    label="电子邮箱"
                                    type="text"
                                    v-model="user.email"
                            ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#368FC8" @click="card = false">取消</v-btn>
                        <v-btn
                                v-if="action === 'add'"
                                color="#368FC8"
                                @click="addUser">确认
                        </v-btn>
                        <v-btn
                                v-if="action === 'edit'"
                                color="#368FC8"
                                @click="editUser">确认
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-card>
</template>

<script>
    export default {
        name: "UserManage",
        inject: ['reload'],
        data: vm => ({
            search: '',
            loading: true,
            overlay: false,
            dialog: false,
            card: false,
            title: '',
            deleteTmp: "",
            uuid: "",
            baseUrl: window.location.href.substring(0, window.location.href.indexOf('webapp')),
            headers: [
                {
                    text: ' 用户名',
                    align: 'center',
                    sortable: false,
                    value: 'username',
                },
                {text: '姓名', align: 'center', sortable: false, value: 'name',},
                {text: '电子邮箱', align: 'center', sortable: false, value: 'email'},
                {text: '操作', align: 'center', sortable: false, value: 'option'},
            ],
            applications: [],
            user: {
                "username": "",
                "password": "",
                "name": "",
                "phoneNumber": "",
                "email": "",
            },
            action: "",
            confirmPassword: "",
            rules: {
                confirmPassword: v => v === vm.user.password || '两次输入的密码不一致',
                required: value => !!value || '必填',
                phone: value => {
                    const pattern = /^1[3456789]\d{9}$/;
                    return pattern.test(value) || '手机格式不正确'
                },
                emailRules: v => /.+@.+\..+/.test(v) || 'E-mail格式不正确',
            },
        }),
        mounted() {
            if (!this.$store.state.landing) {
                this.$snackbar.info('请登录后操作');
                this.$router.push({path: '/login'});
            } else {
                this.getList();
            }
        },
        methods: {
            getList() {
                this.$axios.get('/unicorn/userlist').then((response) => {
                    if (response.data.success) {
                        this.applications = response.data.data;
                        this.$snackbar.info(response.data.content);
                        this.loading = false
                    } else {
                        this.$snackbar.info(response.data.content);
                    }
                }).catch(() => {
                    this.$snackbar.info('连接服务器失败');
                });
            },
            add() {
                this.user.username = '';
                this.user.password = '';
                this.user.name = '';
                this.user.phoneNumber = this.$store.state.webUser.phoneNumber;
                this.user.email = '';
                this.confirmPassword = '';
                this.title = '新增用户';
                this.action = 'add';
                this.card = true;
            },
            edit(item) {
                this.title = '修改用户';
                this.action = 'edit';
                this.card = true;
                this.user.username = item.username;
                this.user.password = '';
                this.user.name = item.name;
                this.user.phoneNumber = item.phoneNumber;
                this.user.email = item.email;
                this.confirmPassword = '';
                this.uuid = item.uuid;
            },
            addUser() {
                if (this.$refs.form.validate()) {
                    this.card = false;
                    this.overlay = true;
                    let formData = new FormData();
                    for (var key in this.user) {
                        formData.append(key, this.user[key]);
                    }
                    this.$axios.post('/unicorn/addhospitaluser', this.user).then((response) => {
                        if (response.data.success) {
                            this.$snackbar.info(response.data.content);
                            this.reload();
                            this.overlay = false;
                        } else {
                            this.$snackbar.info(response.data.content);
                            this.overlay = false;
                        }
                    }).catch(() => {
                        this.$snackbar.info('连接服务器失败');
                        this.overlay = false;
                    });
                }
            },
            editUser() {
                if (this.$refs.form.validate()) {
                    this.card = false;
                    this.overlay = true;
                    this.$axios.get('/unicorn/updatehospitaluser', {
                        params: {
                            uuid: this.uuid,
                            username: this.user.username,
                            password: this.user.password,
                            name: this.user.name,
                            phoneNumber: this.user.phoneNumber,
                            email: this.user.email,
                        }
                    }).then((response) => {
                        if (response.data.success) {
                            this.$snackbar.info(response.data.content);
                            this.reload();
                            this.overlay = false;
                        } else {
                            this.$snackbar.info(response.data.content);
                            this.overlay = false;
                        }
                    }).catch(() => {
                        this.$snackbar.info('连接服务器失败');
                        this.overlay = false;
                    });
                }
            },
            deleteUser(item) {
                this.$axios.post('/unicorn/deletehospitaluser', item).then((response) => {
                    if (response.data.success) {
                        this.$snackbar.info(response.data.content);
                        this.reload();
                        this.overlay = false;
                    } else {
                        this.$snackbar.info(response.data.content);
                        this.overlay = false;
                        this.dialog = false;
                    }
                }).catch(() => {
                    this.$snackbar.info('连接服务器失败');
                    this.overlay = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>